import { service } from '@ember/service';
import Component from '@glimmer/component';
import type AbilitiesService from 'ember-can/services/abilities';

export default class GlobalIntegrationsComponent extends Component {
  @service declare abilities: AbilitiesService;

  get integrationsRoute(): string {
    if (this.abilities.can('visit global-health-dashboard')) {
      return 'location-overview.health-dashboard';
    }
    return 'location-overview.hris-dashboard.dashboard';
  }
}
